import request from '../utils/request'
import { getToken } from '../utils/auth'
export function fetchGPSNotificationList(filter) {
  return request({
    url: '/api/gps_notifications',
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function createGPSNotification(data) {
  return request({
    url: '/api/gps_notifications',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}



